import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import SummarySellerTiles from './SellerTiles';
import { StoreBasicDataApiStructure } from 'common/types';
import { repositories } from 'api';
import { getIsUserPromoter } from 'store/ducks/me/selectors';

type Props = {
    isPromoter: boolean,
    email: string | undefined | null,
};

const SummaryEmailClientPanel: React.FC<Props> = ({ isPromoter, email, }) => {
    if (!isPromoter || !email) {
        return null;
    }

    return (
        <SummarySellerTiles renderHeader="E-mail klienta">
            <Grid container
                  direction="column">
                <Typography variant="subtitle1">
                    {email}
                </Typography>
            </Grid>
        </SummarySellerTiles>
    );
};

type MappingType = {
    me: StoreBasicDataApiStructure<repositories.MeType>,
    checkout: {
        values: any,
    }
};

const mapStateToProps = (state: MappingType) => ({
    isPromoter: getIsUserPromoter(state),
    email: state.checkout.values?.email,
});

export default connect(
    mapStateToProps,
)(SummaryEmailClientPanel);
